import React from "react";
import { fmtCount, imageUrl } from "../api";

export default function LeadCard({ lead }) {
  return (
    <div className="card lead">
      <a className="lead-head" href={lead.ig_url} target="_blank" rel="noreferrer">
        <img className="avatar" src={imageUrl(lead.id)} alt="" loading="lazy" />
        <div className="lead-id">
          <div className="uname">
            @{lead.username}
            {lead.verified && <span className="verified" title="Verified">✓</span>}
          </div>
          {lead.full_name && <div className="muted fullname">{lead.full_name}</div>}
        </div>
        <span className={`score ${lead.score >= 80 ? "hi" : lead.score >= 60 ? "mid" : "lo"}`} title="Match confidence">
          {lead.score}
        </span>
      </a>
      <div className="stats">
        <span><strong>{fmtCount(lead.followers)}</strong> followers</span>
        <span><strong>{fmtCount(lead.posts)}</strong> posts</span>
        {lead.location && <span className="loc">📍 {lead.location}</span>}
      </div>
      {lead.category && <div className="meta"><span className="badge">{lead.category}</span></div>}
      {lead.bio && <div className="bio">{lead.bio}</div>}
      <div className="reason">{lead.reason}</div>
      <div className="lead-foot muted">
        <span>via {lead.found_via}</span>
        {lead.external_url && (
          <a href={lead.external_url} target="_blank" rel="noreferrer" className="ext-link">
            link ↗
          </a>
        )}
      </div>
    </div>
  );
}
